import Component from "@glimmer/component";
import { guidFor } from "@ember/object/internals";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { oneOf } from "prop-types";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsInfo from "glesys-controlpanel/components/icons/info";
import { t } from "ember-intl";

@forbidExtraArgs
export default class InfoPopup extends Component {
  @arg(oneOf([null, "orange", "red"])) iconColor;

  tooltipId = `info-popup-${guidFor(this)}`;

  get iconColorClass() {
    switch (this.iconColor) {
      case "orange":
        return "stroke-orange-200 group-hover:stroke-orange-800";
      case "red":
        return "stroke-red-800";
      default:
        return "stroke-gray-400 group-hover:stroke-gray-800";
    }
  }

  <template>
    <span class="group [anchor-scope:all] inline-flex" data-test-info-popup {{mergeClasses}} ...attributes>
      <button
        class="[anchor-name:--info-popup] inline-flex h-4 text-left text-gray-500 font-normal text-xs whitespace-normal bg-transparent border-0 p-0"
        aria-label={{t "label.information"}}
        aria-describedby={{this.tooltipId}}
        type="button"
      >
        <IconsInfo class="info w-4 inline-flex self-center relative z-8 cursor-pointer {{this.iconColorClass}}" />
      </button>
      <span
        class="fixed [position-anchor:--info-popup] top-[calc(anchor(bottom)+--spacing(2))] left-[anchor(left)] [position-try-fallbacks:flip-inline_flip-block] invisible w-64 text-sm transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 group-hover:visible group-hover:opacity-100 group-has-focus-visible:visible group-has-focus-visible:opacity-100 px-3 py-2 select-text z-10"
        id={{this.tooltipId}}
        role="tooltip"
      >
        {{yield}}
      </span>
    </span>
  </template>
}
